"use client";

import Calculator, {
	useCalculator,
} from "@clayton-homes/home-designer/components/calculator";

export default function HowItWorksCalculator() {
	const calculatorInstance = useCalculator({
		initState: {
			annualInsuranceMax: 4000,
		},
	});

	return <Calculator useCalculatorInstance={calculatorInstance} />;
}
